import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
    Alert
} from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';

export default function DeleteBarDialog({ open, onClose, onConfirm, bar }) {
    if (!bar) return null;

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: 1,
                color: 'error.main' 
            }}>
                <WarningIcon color="error" />
                Confirm Bar Deletion
            </DialogTitle>
            <DialogContent>
                <Alert severity="warning" sx={{ mb: 2 }}>
                    This action cannot be undone!
                </Alert>
                <Typography variant="body1" gutterBottom>
                    You are about to delete <strong>{bar.barName}</strong>. This will permanently delete:
                </Typography>
                <Box sx={{ pl: 2, my: 2 }}>
                    <Typography component="li">All bar information and settings</Typography>
                    <Typography component="li">All blast history ({bar.blastCount || 0} blasts)</Typography>
                    <Typography component="li">All user data ({bar.userCount || 0} users)</Typography>
                    <Typography component="li">All analytics and metrics</Typography>
                </Box>
                <Typography variant="body1" color="error">
                    Are you sure you want to proceed with deletion?
                </Typography>
            </DialogContent>
            <DialogActions sx={{ p: 2, pt: 0 }}>
                <Button onClick={onClose}>
                    Cancel
                </Button>
                <Button 
                    onClick={onConfirm}
                    variant="contained" 
                    color="error"
                >
                    Delete Bar
                </Button>
            </DialogActions>
        </Dialog>
    );
} 